import { useConfig } from "utils/ConfigService";

export function useEmailDomain(): [domain: string, isLoading: boolean] {
  const [config, isLoading] = useConfig();
  return [config?.emailDomain || "email.snobase.com", isLoading];
}

export function usePitchableEmailDomain(): [
  domain: string,
  isLoading: boolean,
] {
  const [config, isLoading] = useConfig();
  return [config?.pitchableEmailDomain || "pitchable.rodeocpg.io", isLoading];
}
